import BaseModel from '@danhoss/model/BaseModel';
import { ModelCollectionType} from '@danhoss/model/types';

export class AdditionalProductsModel extends BaseModel {
    constructor() {
        super();

        this._categories = new ModelCollectionType('CategoryModel');
        this._products = new ModelCollectionType('ProductModel');
    }

    get categories() {
        return this._categories;
    }

    set categories(value) {
        this._categories = value;
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }
}
